import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Login from "./login/Login";
import Dashboard from "./dashboard/dashboard";
import Payoutreport from "./component/Reports/Payoutreport";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/payoutreport" element={<Payoutreport />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
